module.exports = __webpack_public_path__ + "static/img/avatar-s-10.7be10c57.png";